import React from "react";
import BeatLoader from "react-spinners/BeatLoader";

const DotSpinner = ({ size, color }) => {
	return <BeatLoader size={size} color={color} />;
};

export default DotSpinner;
